import styled from 'styled-components';
import { FiChevronDown } from 'react-icons/fi';
import { useState } from 'react';
import palette from 'lib/styles/palette';
import usePlaceSelector from 'hooks/place/usePlaceSelector';

const PlaceSelector = () => {
  const [showBox, setShowBox] = useState(false);

  const { floor, onSelect } = usePlaceSelector();

  const BXArr = Object.keys([...Array(10)])
    .map(el => Number(el) + 1)
    .reverse()
    .map(el => `B${String(el)}`);

  const FloorArr = Object.keys([...Array(50)]).map(
    el => String(Number(el) + 1) + 'F',
  );

  const selectorArr = [...BXArr, ...FloorArr];

  return (
    <SelectBlock>
      <div className="wrapper" onClick={() => setShowBox(true)}>
        <div>{floor}</div>
        <FiChevronDown />
      </div>
      {showBox && (
        <OptionBox>
          {selectorArr.map(floor => (
            <div
              className="option"
              key={floor}
              onClick={e => {
                onSelect(e);
                setShowBox(false);
              }}
            >
              {floor}
            </div>
          ))}
        </OptionBox>
      )}
    </SelectBlock>
  );
};

const SelectBlock = styled.div`
  width: 50px;
  border: 1px solid black;
  border-radius: 8px;
  font-size: 12px;
  position: relative;

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2px 7px;
    cursor: pointer;
  }
`;

const OptionBox = styled.div`
  width: 60px;
  height: 100px;
  padding: 2px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
  background: #fff;
  overflow-y: scroll;
  position: absolute;
  top: -30px;
  left: -5px;
  z-index: 300;
  &::-webkit-scrollbar {
    width: 7px;
    background: ${palette.theme[0]};
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${palette.theme[3]};
    border-radius: 10px;
  }

  .option {
    margin-top: 3px;
    cursor: pointer;
  }
`;

export default PlaceSelector;
